import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Result } from '../models/result';
import { getSchoolById, getAcademicYears, getClassesForSchool } from '../repositories/school/schoolRepo';
import SCHOOL_CONFIG from '../config/appConfig';

const useSchoolStore = create(
  persist(
    (set, get) => ({
      // State
      schoolId: null,
      schoolData: null,
      isLoading: false,
      isClassesLoading: false,
      academicYears: [],
      classes: [],
      error: null,

      // Actions
      setSchoolId: (schoolId) => {
          if (!schoolId) {
            return new Result({ message: 'School ID is required' });
          }
       
          set({ schoolId, error: null });
          return schoolId;
      },

      getSchoolId: () => {
        const { schoolId } = get();
        return schoolId;
      },

      getSchoolData: async () =>{
        /** Fetches the fresh school data from the database */
        const { schoolId } = get();
        const result = await getSchoolById(schoolId);
        if(result.success){
          set({ schoolData: result.value, error: null});
            return new Result({ value: result.value });
        }else{
          console.log(`Error fetching school data: ${result.message}`);
            return new Result({ message: result.message });
        }
      },

      setSchoolData: async (schoolId) => {
        try {
            const {schoolData:currSchoolData, getSchoolData} = get();
            let schoolData = currSchoolData;
            if(!schoolData){
                set({isLoading: true});
                var result = await getSchoolData();
                if(!result.success){
                  set({ error: result, isLoading: false });
                }else{
                  set({ schoolData: result.value, error: null, isLoading: false });
                }
            }
         
          if(schoolData){
            set({ schoolData: schoolData, error: null, isLoading: false, currentAcademicYear: schoolData.currentAcademicYear });
            SCHOOL_CONFIG.id = schoolId;
            SCHOOL_CONFIG.name = schoolData.name;
            SCHOOL_CONFIG.tagline = schoolData.tagline;
            return new Result({ value: schoolData });
          }
        } catch (error) {
          set({ error: error, isLoading: false });
          return new Result({ message: error.message });
        }
      },

      getClasses: async () => {
        const { schoolId, classes } = get();
        if (!schoolId) {
          return new Result({ message: 'School ID is required' });
        }

        if(classes && classes.length > 0){
          return new Result({ value: classes });
        }

        set({isClassesLoading: true});
        const result = await getClassesForSchool(schoolId);
        if(result.success){
          set({ classes: result.value, isClassesLoading: false });
          return new Result({ value: result.value });
        }
        set({isClassesLoading: false, error: result});
 
        
      },

      getAcademicYears: async () => {
        const { schoolId, academicYears } = get();
        if (!schoolId) {
          return new Result({ message: 'School ID is required' });
        }
        
        // If academicYears already has data, return it immediately
        if (academicYears && academicYears.length > 0) {
          return new Result({ value: academicYears });
        }
        
        set({isLoading: true});
        // Otherwise, fetch fresh data
        const result = await getAcademicYears(schoolId);
        if (result.success) {
          set({ academicYears: result.value, isLoading: false });
          return new Result({ value: result.value });
        }
        set({isLoading: false, error: result});
        return result;
      },

      clearSchoolData: (isLogout = false) => {
        set({ 
          schoolId: isLogout ?  get().schoolId : null, 
          schoolData: null, 
          error: null,
          classes: [],
          academicYears: []
        });
        return new Result({ value: true });
      },

      setLoading: (isLoading) => {
        set({ isLoading });
        return new Result({ value: isLoading });
      },

      clearError: () => {
        set({ error: null });
        return new Result({ value: true });
      },

      // Helper method to check if school context is set
      hasSchoolContext: () => {
        const { schoolId } = get();
        return new Result({ value: !!schoolId });
      },

      clearError: () => {
        set({ error: null });
        return new Result({ value: true });
      }
    }),
    {
      name: 'school-storage',
      partialize: (state) => ({
        schoolId: state.schoolId,
        schoolDbId: state.schoolDbId,
        schoolData: state.schoolData,
        classes: state.classes,
        academicYears: state.academicYears,
      })
    }
  )
);

export default useSchoolStore; 